import { render, staticRenderFns } from "./XcxManage.vue?vue&type=template&id=127bc2a5&scoped=true&"
import script from "./XcxManage.vue?vue&type=script&lang=js&"
export * from "./XcxManage.vue?vue&type=script&lang=js&"
import style0 from "./XcxManage.vue?vue&type=style&index=0&id=127bc2a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127bc2a5",
  null
  
)

export default component.exports